import React from 'react'
import { connect } from 'react-redux'

import { fetchUsersList, fetchUser } from '../Users/actions'

import './MyAccount.css'

let chkReturn = 0;

class MyAccount extends React.Component {
    constructor(props) {
        super(props);

        this.fetchUsersVerify = this.fetchUsersVerify.bind(this);
    }

    componentWillMount() {
        this.props.dispatch(fetchUsersList)

        chkReturn = setInterval(this.fetchUsersVerify, 100);
    }

    fetchUsersVerify() {

        if (this.props.users.fetched || this.props.users.error) {

            clearInterval(chkReturn);
            chkReturn = 0;

            var _this = this
            var curUser = this.props.users.users.filter((user) => { return user.userName == _this.props.users.user })[0]

            fetchUser.bind(this)(curUser.id)
        }
    }

    onCancel() {
        window.history.back()
    }

    render() {
        return (
            this.props.valid ?
                <div className="myAccount col-xs-12">
                    <a className="btn detail-cancel btn-default" onClick={this.onCancel} >Cancel</a>

                    <div className="headWrapper">
                        <div className="account">
                            <h1>My Account</h1>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12">
                            <div className="details-blk header-top">
                                <p className="details-blk-hdg">User Info</p>

                                <div className="row child-row">
                                    <div className="col-md-4">
                                        <p className="blk-label">User:</p>
                                        <span>{this.props.user.userName}</span>
                                    </div>
                                    <div className="col-md-4">
                                        <p className="blk-label">10 Character ID:</p>
                                        <span>{this.props.user.userName.substr(0, 10)}</span>
                                    </div>
                                    <div className="col-md-4">
                                        <p className="blk-label">UPN User Principal Name:</p>
                                        <span>{this.props.user.userPrincipalName}</span>
                                    </div>
                                </div>
                                <div className="row child-row">
                                    <div className="col-md-4">
                                        <p className="blk-label">First Name:</p>
                                        <span>{this.props.user.firstName}</span>
                                    </div>
                                    <div className="col-md-4">
                                        <p className="blk-label">Middle Name:</p>
                                        <span>{this.props.user.middleName}</span>
                                    </div>
                                    <div className="col-md-4">
                                        <p className="blk-label">Last Name:</p>
                                        <span>{this.props.user.lastName}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12">
                            <div className="details-blk">
                                <p className="details-blk-hdg">Contact Info</p>

                                <div className="row child-row">
                                    <div className="col-md-4">
                                        <p className="blk-label">Office Telephone:</p>
                                        <span>{this.props.user.officePhone}</span>
                                    </div>
                                    <div className="col-md-4">
                                        <p className="blk-label">Office Extension:</p>
                                        <span>{this.props.user.officeExt}</span>
                                    </div>
                                    <div className="col-md-4">
                                        <p className="blk-label">Office Fax:</p>
                                        <span>{this.props.user.officeFax}</span>
                                    </div>
                                </div>
                                <div className="row child-row">
                                    <div className="col-md-4">
                                        <p className="blk-label">Mobile Telephone:</p>
                                        <span>{this.props.user.mobilePhone}</span>
                                    </div>
                                    <div className="col-md-4">
                                        <p className="blk-label">Other Mobile:</p>
                                        <span>{this.props.user.otherMobile}</span>
                                    </div>
                                    <div className="col-md-4">
                                        <p className="blk-label">House Telephone:</p>
                                        <span>{this.props.user.housePhone}</span>
                                    </div>
                                </div>
                                <div className="row child-row">
                                    <div className="col-md-4">
                                        <p className="blk-label">Email:</p>
                                        <span>{this.props.user.email}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12">
                            <div className="details-blk">
                                <p className="details-blk-hdg">Address Info</p>

                                <div className="row child-row">
                                    <div className="col-md-4">
                                        <p className="blk-label">Address1:</p>
                                        <span>{this.props.user.addressInformation ? this.props.user.addressInformation.addressLine1 : null}</span>
                                    </div>
                                    <div className="col-md-4">
                                        <p className="blk-label">Address2:</p>
                                        <span>{this.props.user.addressInformation ? this.props.user.addressInformation.addressLine2 : null}</span>
                                    </div>
                                    <div className="col-md-4">
                                        <p className="blk-label">City:</p>
                                        <span>{this.props.user.addressInformation ? this.props.user.addressInformation.city : null}</span>
                                    </div>
                                </div>
                                <div className="row child-row">
                                    <div className="col-md-4">
                                        <p className="blk-label">State:</p>
                                        <span>{this.props.user.addressInformation ? this.props.user.addressInformation.stateCode : null}</span>
                                    </div>
                                    <div className="col-md-4">
                                        <p className="blk-label">Zip:</p>
                                        <span>{this.props.user.addressInformation ? this.props.user.addressInformation.postalCode : null}</span>
                                    </div>
                                    <div className="col-md-4">
                                        <p className="blk-label">Country:</p>
                                        <span>{this.props.user.addressInformation ? this.props.user.addressInformation.country : null}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12">
                            <div className="details-blk">
                                <p className="details-blk-hdg">Organizational Info</p>

                                <div className="row child-row">
                                    <div className="col-md-4">
                                        <p className="blk-label">Department:</p>
                                        <span>{this.props.user.department}</span>
                                    </div>
                                    <div className="col-md-4">
                                        <p className="blk-label">Job Title:</p>
                                        <span>{this.props.user.title}</span>
                                    </div>
                                    <div className="col-md-4">
                                        <p className="blk-label">Location:</p>
                                        <span>{this.props.user.location}</span>
                                    </div>
                                </div>
                                <div className="row child-row">
                                    <div className="col-md-4">
                                        <p className="blk-label">Manager:</p>
                                        <span>{this.props.user.manager}</span>
                                    </div>
                                    <div className="col-md-4">
                                        <p className="blk-label">Houzz URL:</p>
                                        <span>{this.props.user.houzzUrl}</span>
                                    </div>
                                    <div className="col-md-4">
                                        <p className="blk-label">Credentials:</p>
                                        <span>{this.props.user.credentials}</span>
                                    </div>
                                </div>
                                <div className="row child-row">
                                    <div className="col-md-4">
                                        <p className="blk-label">Employee GUID:</p>
                                        <span>{this.props.user.employeeGUID}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
            : null
        );
    }
}

const mapStateToProps = state => ({
    valid: state.user.updated,
    user: state.user.user,
    users: state.users
});

export default connect(mapStateToProps)(MyAccount)
